import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { percentOf } from '../../common/SplitProgressBarChart/util';
import Indicator from '../../common/SplitProgressBarChart/Indicator';

type ProgressBarProps = {
  metColor: string;
  notMetColor: string;
  metDescription?: any;
  MetEndAdornment?: any;
  notMetDescription?: any;
  NotMetEndAdornment?: any;
  descriptionWidth?: any;
  title: string;
  completed: number;
  supports: any;
  width: any;
  didNotUseSupports: any;
};

const StudentSupportBar = ({
  metColor,
  notMetColor,
  metDescription,
  MetEndAdornment,
  title,
  completed,
  supports,
  notMetDescription,
  width,
  NotMetEndAdornment,
  didNotUseSupports
}: ProgressBarProps) => {
  const classes = useStyles();
  const mainRef: any = React.useRef(null);
  const grey = '#919191';
  const [mainWidth, setWidth] = React.useState(0);

  React.useEffect(() => {
    if (!mainRef.current) return;
    setWidth(mainRef.current?.offsetWidth);
  }, [setWidth]);

  return (
    <Box display="flex" flex={1} flexDirection="column" position="relative" marginBottom={3}>
      <Box display="flex" flexDirection="row" justifyContent="space-between" marginBottom="2px">
        <Typography style={{ fontSize: 24 }}>{title}</Typography>
      </Box>

      <div className={classes.notMet} style={{ width: `${width}%`, backgroundColor: grey }}>
        {supports > 0 && <Indicator color={metColor} style={{ height: 68 }} />}
        <div
          ref={mainRef}
          className={classes.notMet}
          style={{
            top: 26,
            backgroundColor: notMetColor,
            width: `${percentOf(supports, completed)}%`
          }}
        >
          {supports > 0 && (
            <Box display="flex" flex={1}>
              <Typography style={{ color: '#fff', marginLeft: 8 }}>{supports}</Typography>
            </Box>
          )}
          {didNotUseSupports > 0 && (
            <Box display="flex">
              <Typography style={{ color: '#fff', position: 'absolute', marginLeft: 7 }}>
                {didNotUseSupports}
              </Typography>
            </Box>
          )}
        </div>
        {didNotUseSupports > 0 && (
          <>
            <Indicator color={grey} />
            <Typography
              className="notMetDescription"
              style={{
                display: 'flex',
                width: '10',
                fontSize: 18,
                marginTop: 17,
                marginLeft: `${mainWidth + 10}px`,
                position: 'absolute',
                whiteSpace: 'nowrap',
                verticalAlign: 'center'
              }}
            >
              {notMetDescription}
              {NotMetEndAdornment}
            </Typography>
          </>
        )}
      </div>

      <Box display="flex" flex={1} width="max-content">
        <Typography
          noWrap
          style={{
            display: 'flex',
            marginLeft: 11,
            fontSize: 18,
            alignItems: 'flex-end',
            marginTop: 25,
            position: 'absolute'
          }}
        >
          {supports > 0 && (
            <>
              {metDescription}
              {MetEndAdornment}
            </>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  notMet: {
    display: 'flex',
    height: 22,
    borderRadius: '8px'
  },
  met: {
    display: 'flex',
    height: 22,
    justifyContent: 'flex-end',
    borderRadius: '8px 0px 0px 8px',
    marginTop: -22
  },
  icon: {
    marginLeft: 2
  }
}));
export default StudentSupportBar;
